<template>
<div class="technology">
  <div class="container">
    <h2 class="text-center mb-5">Folgende Technologien setzen wir für Sie ein</h2>
    
    <div class="row">
<TechnologyCard
  img-src="/img/docker-logo.png"
  title="Docker"
  description="Docker ist eine Open-Source-Plattform, die es Entwicklern ermöglicht, Anwendungen in Containern zu verpacken und zu verteilen, um eine konsistente Umgebung von der Entwicklung bis zur Produktion zu gewährleisten."
/>
<TechnologyCard
  img-src="/img/kubernetes-logo.png"
  title="Kubernetes"
  description="Kubernetes ist eine Open-Source-Plattform zur Automatisierung der Bereitstellung, Skalierung und Verwaltung von containerisierten Anwendungen."
/>

<TechnologyCard
  img-src="/img/terraform-logo.png"
  title="Terraform"
  description="Terraform ist ein Open-Source-Infrastructure-as-Code-Software-Tool, das von HashiCorp entwickelt wurde und es Benutzern ermöglicht, Rechenzentrumsinfrastruktur mithilfe einer Hochsprache zu definieren und bereitzustellen."
/>

<TechnologyCard
  img-src="/img/ansible-logo.png"
  title="Ansible"
  description="Ansible ist ein Open-Source-Tool für Automatisierung, Konfigurationsmanagement und IT-Orchestrierung."
/>
<TechnologyCard
  img-src="/img/puppet-logo.png"
  title="Puppet"
  description="Puppet ist eine Open-Source-Software-Konfigurationsmanagement-Tool, das es ermöglicht, die Konfiguration und Verwaltung von Servern zu automatisieren."
/>

<TechnologyCard
  img-src="/img/aws-logo.png"
  title="AWS"
  description="Amazon Web Services (AWS) bietet eine breite Palette an Cloud-Diensten, die von Computing und Speicher bis hin zu maschinellem Lernen und künstlicher Intelligenz reichen."
/>
<TechnologyCard
  img-src="/img/azure-logo.png"
  title="Azure"
  description="Microsoft Azure ist eine Cloud-Computing-Plattform und ein Dienst, der von Microsoft angeboten wird, um Anwendungen über ein globales Netzwerk von Rechenzentren zu erstellen, zu testen, bereitzustellen und zu verwalten."
/>

<TechnologyCard
  img-src="/img/jenkins-logo.png"
  title="Jenkins"
  description="Jenkins ist ein Open-Source-Automatisierungsserver, der es ermöglicht, Softwareprojekte kontinuierlich zu entwickeln, zu testen und bereitzustellen."
/>
<TechnologyCard
  img-src="/img/gitlab-logo.png"
  title="GitLab"
  description="GitLab ist eine Web-basierte DevOps-Plattform, die eine vollständige CI/CD-Pipeline und Source-Code-Management bietet."
/>

<TechnologyCard
  img-src="/img/golang-logo.png"
  title="Golang"
  description="Golang, oder Go, ist eine statisch typisierte, kompilierte Programmiersprache, die für ihre Einfachheit und Leistung bekannt ist und sich ideal für Backend-Dienste eignet."
/>
<TechnologyCard
  img-src="/img/python-logo.png"
  title="Python"
  description="Python ist eine vielseitige Sprache, die für ihre Benutzerfreundlichkeit und breite Anwendungsmöglichkeiten bekannt ist, von der Webentwicklung bis zur Datenwissenschaft."
/>

<TechnologyCard
  img-src="/img/splunk-logo.png"
  title="Splunk"
  description="Splunk ist eine Plattform für das Suchen, Überwachen und Analysieren von maschinell generierten Big Data, über eine webbasierte Oberfläche."
/>
<TechnologyCard
  img-src="/img/prometheus-logo.png"
  title="Prometheus"
  description="Prometheus ist ein Open-Source-Monitoring- und Alarmsystem, das speziell für die Zuverlässigkeit und Skalierbarkeit von Microservices entwickelt wurde."
/>
<TechnologyCard
  img-src="/img/grafana-logo.png"
  title="Grafana"
  description="Grafana ist ein Open-Source-Analyse- und Überwachungswerkzeug, das es ermöglicht, Dashboards für die Visualisierung von Metriken aus verschiedenen Datenquellen zu erstellen."
/>
    </div>
  </div>
</div>
</template>

<script>
import TechnologyCard from '../components/TechnologyCard.vue';

export default {
  name: 'AppTechnology',
  components: {
    TechnologyCard
  }
};
</script>

<style>
.technology {
	padding: 100px 0;
}

h1 {
  margin-top: 20px;
}
.row {
  margin-top: 40px;
}
</style>

